import { render, staticRenderFns } from "./WidgetContent.vue?vue&type=template&id=4ca28cb7&scoped=true&"
import script from "./WidgetContent.vue?vue&type=script&lang=js&"
export * from "./WidgetContent.vue?vue&type=script&lang=js&"
import style0 from "./WidgetContent.vue?vue&type=style&index=0&id=4ca28cb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca28cb7",
  null
  
)

export default component.exports